<template>
  <div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.PASSPORT_SERIAL }}</p>
      <p class="min-h-6">{{ personDocument?.series }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.PASSPORT_NUMBER }}</p>
      <p class="min-h-6">{{ personDocument?.number }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.ISSUED_BY }}</p>
      <p class="min-h-6">{{ personDocument?.issuedBy }}</p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.ISSUED_DATE }}</p>
      <p class="min-h-6">
        {{ personDocument?.docFrom ? $moment(personDocument?.docFrom).format('DD.MM.YYYY') : '' }}
      </p>
      <hr />
    </div>
    <div class="my-5">
      <p class="text-xs text-gray-500">{{ $lang.app.EXPIRATION_DATE }}</p>
      <p class="min-h-6">
        {{ personDocument?.docTo ? $moment(personDocument?.docTo).format('DD.MM.YYYY') : '' }}
      </p>
      <hr />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    personDocument: Object,
  }
}
</script>